<template>
    <div>
        <headTop v-if="$route.name !== 'UserLogout'"></headTop>
        <router-view :key="$route.fullPath"></router-view>
        <bottomCom v-if="$route.name !== 'UserLogout'"></bottomCom>
    </div>
</template>
<script>
import headTop from "./components/headTop";
import bottomCom from "./components/bottomCom";
export default {
    data() {
        return {};
    },
    components: {
        headTop,
        bottomCom,
    },
    methods: {},
};
</script>
<style lang="scss">
* {
    margin: 0;
    padding: 0;
    // overflow: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* Internet Explorer 10+ */
    // ::-webkit-scrollbar {
    //     display: none; /* 隐藏滚动条 */
    // }
}
</style>
